import { render, staticRenderFns } from "./EditMainGoalsDialog.vue?vue&type=template&id=16e475ee&scoped=true"
import script from "./EditMainGoalsDialog.vue?vue&type=script&lang=js"
export * from "./EditMainGoalsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditMainGoalsDialog.vue?vue&type=style&index=0&id=16e475ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e475ee",
  null
  
)

export default component.exports